<template>
  <div
    class="shadow-box"
    :class="opacity"
    @click="handleClickShadowBox"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ShadowBox',

  props: {
    opacity: {
      type: String,
      default: '_65',
    },
  },

  methods: {
    handleClickShadowBox(e) {
      this.$emit('handleClickShadowBox', e);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
